import React from "react";

export default function FloatingBanner({ type = "success", message, onClose }) {
  const colors = {
    success: {
      bg: "bg-green-100",
      border: "border-green-400",
      text: "text-green-800",
      close: "text-green-700 hover:text-green-900"
    },
    error: {
      bg: "bg-red-100",
      border: "border-red-400",
      text: "text-red-800",
      close: "text-red-700 hover:text-red-900"
    },
    warning: {
      bg: "bg-yellow-100",
      border: "border-yellow-400",
      text: "text-yellow-800",
      close: "text-yellow-700 hover:text-yellow-900"
    }
  };

  const theme = colors[type] || colors.success;

  return (
    <div className={`fixed top-6 right-6 z-50 max-w-sm w-full px-4 py-3 rounded shadow-md ${theme.bg} ${theme.border}`}>
      <div className="flex justify-between items-start">
        <span className={`text-sm font-medium ${theme.text}`}>{message}</span>
        <button
          onClick={onClose}
          className={`ml-4 ${theme.close}`}
          aria-label="Close"
        >
          ✕
        </button>
      </div>
    </div>
  );
}
